<div class="reward-info-root">
  <h2>{{ labels.generalInfo | transloco }}</h2>

  <p class="reward-points">
    <mat-icon>stars</mat-icon>
    {{ data.rewardCost | number:'': language  }}
  </p>

  <section class="reward-info">
    <ng-container *ngFor="let generalInfoRow of generalInfoRows">
      <div *ngIf="generalInfoRow.display" class="reward-info-row">
        <p>{{ generalInfoRow.label }}</p>

        <ng-container
          *ngIf="generalInfoRow.values.length === 1; else multipleValuesRow"
        >
          <p
            [matTooltip]="getTooltipContent(generalInfoRow.values[0])"
            [matTooltipClass]="'lnr-mat-tooltip-black'"
            [matTooltipPosition]="'right'"
          >
            <strong>{{ generalInfoRow.values[0] }}</strong>
          </p>
        </ng-container>

        <ng-template #multipleValuesRow>
          <div class="multiple-values-row">
            <strong *ngFor="let value of generalInfoRow.values">{{
              value
            }}</strong>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </section>

  <h2>{{ labels.locationRestriction | transloco }}</h2>

  <section class="reward-info">
    <ng-container
      *ngFor="let locationRestrictionRow of locationRestrictionRows"
    >
      <div *ngIf="locationRestrictionRow.display" class="reward-info-row">
        <p>{{ locationRestrictionRow.label }}</p>

        <ng-container
          *ngIf="
            locationRestrictionRow.values.length === 1;
            else multipleValuesRow
          "
        >
          <p
            [matTooltip]="getTooltipContent(locationRestrictionRow.values[0])"
            [matTooltipClass]="'lnr-mat-tooltip-black'"
            [matTooltipPosition]="'right'"
          >
            <strong>{{ locationRestrictionRow.values[0] }}</strong>
          </p>
        </ng-container>

        <ng-template #multipleValuesRow>
          <div class="multiple-values-row">
            <strong *ngFor="let value of locationRestrictionRow.values">{{
              value
            }}</strong>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </section>
</div>
